import React from 'react';
import { Chip, Stack } from '@mui/material';
import type { Category } from '../data/projects';
import { ALL_CATEGORY } from '../data/projects';

interface CategoryFilterProps {
  categories: Category[];
  /** Currently selected category id, or ALL_CATEGORY. */
  selected: string;
  onSelect: (id: string) => void;
}

/** Filter chips: an "Alle" chip plus one per category. Presentational. */
const CategoryFilter: React.FC<CategoryFilterProps> = ({ categories, selected, onSelect }) => {
  const options: Category[] = [{ id: ALL_CATEGORY, label: 'Alle' }, ...categories];

  return (
    <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap" justifyContent="center" sx={{ mb: 4 }}>
      {options.map((option) => {
        const active = option.id === selected;
        return (
          <Chip
            key={option.id}
            label={option.label}
            clickable
            color={active ? 'primary' : 'default'}
            variant={active ? 'filled' : 'outlined'}
            onClick={() => onSelect(option.id)}
            aria-pressed={active}
            sx={active ? undefined : { color: 'common.white', borderColor: 'rgba(255,255,255,0.6)' }}
          />
        );
      })}
    </Stack>
  );
};

export default CategoryFilter;
